import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Stack, Typography, InputAdornment } from '@mui/material'
import SendIcon from '@mui/icons-material/Send'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'

import AppModal from './AppModal'
import FormTextField from './FormTextField'
import SubmitButton from '../buttons/SubmitButton'

interface AppEmailModalProps {
  open: boolean
  onClose: () => void
  onSubmit: (email: string) => void
  title?: string
  description?: string
  loading?: boolean
  initialEmail?: string
  submitText?: string
}

interface EmailFormValues {
  email: string
}

const validationSchema = Yup.object({
  email: Yup.string().email('Please enter a valid email address').required('Email is required')
})

const AppEmailModal: React.FC<AppEmailModalProps> = ({
  open,
  onClose,
  onSubmit,
  title = 'Send Email',
  description = 'Please provide a valid email address.',
  loading = false,
  initialEmail = '',
  submitText = 'Send Email'
}) => {
  const initialValues: EmailFormValues = {
    email: initialEmail
  }

  return (
    <AppModal open={open} onClose={onClose} title={title} width="sm" loading={loading}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {description}
      </Typography>

      <Formik<EmailFormValues>
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSubmit(values.email)
        }}
      >
        {() => (
          <Form>
            <Stack spacing={3}>
              <FormTextField
                name="email"
                label="Email Address"
                placeholder="e.g. user@example.com"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlinedIcon color="action" />
                      </InputAdornment>
                    )
                  }
                }}
              />

              <SubmitButton
                loading={loading}
                title={submitText}
                loadingText="Sending..."
                endIcon={<SendIcon />}
              />
            </Stack>
          </Form>
        )}
      </Formik>
    </AppModal>
  )
}

export default AppEmailModal
